import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BrandingAngularModule } from 'rev-portal/branding/BrandingAngular.Module';
import { IWebcastBrandingSettings } from 'rev-portal/scheduledEvents/webcast/WebcastBranding';
import { DateAngularModule } from 'rev-shared/date/DateAngular.Module';
import { PipesAngularModule } from 'rev-shared/pipes/Pipes.AngularModule';
import { VbUiToggleContentDisplayAngularModule } from 'rev-shared/ui/toggleContentDisplay/VbUiTogleContentDisplay.AngularModule';
import { DirectivesAngularModule } from 'rev-shared/util/directives/DirectivesAngular.Module';

import { WebcastSpeakersComponent } from './WebcastSpeakers.Component';

@Component({
	selector: 'webcast-info-view',
	templateUrl: './WebcastInfoView.Component.html',
	styleUrl: './WebcastInfoView.ng.less',
	imports: [
		CommonModule,
		DateAngularModule,
		DirectivesAngularModule,
		BrandingAngularModule,
		PipesAngularModule,
		VbUiToggleContentDisplayAngularModule,
		WebcastSpeakersComponent,
	]
})
export class WebcastInfoViewComponent implements OnInit {
	@Input() public webcast: any;
	@Input() public noHeader: boolean;
	@Input() public noContent: boolean;

	public brandingSettings: IWebcastBrandingSettings;
	public hasBanner: boolean;

	public ngOnInit(): void {
		this.brandingSettings = this.webcast.brandingSettings || {};
		this.hasBanner = this.brandingSettings.bannerImageUri ||
			this.brandingSettings.speakerProfiles?.length > 0 as any;
	}
}
